
import Header from "@/components/Header";
import CollectionsView from "@/components/CollectionsView";
import SocialMediaIcons from "@/components/SocialMediaIcons";

const HistoryPage = () => {
  return (
    <div className="min-h-screen bg-tokscript-bg text-tokscript-text flex flex-col">
      <Header />
      <main className="flex-1 pt-8">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl font-bold mb-6">Download History</h1>
          <CollectionsView />
        </div>
      </main>
      <footer className="border-t border-gray-800 py-6">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center px-4">
          <div className="mb-4 md:mb-0">
            <div className="text-xl font-bold">
              <span className="text-white">tok</span>
              <span className="text-tokscript-cta">script</span>
            </div>
            <p className="text-sm text-gray-400 mt-1">© 2024 TokScript. All rights reserved.</p>
          </div>
          <SocialMediaIcons />
        </div>
      </footer>
    </div>
  );
};

export default HistoryPage;
